import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconHeartFilled$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconHeartFilled extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '4cdcc2659d28ab1c854ff08cbb245cf313ee84a6', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'bf939cecd47e9444c48dab6165cc4da3a9864c38', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'f1709eb71b6e5c8dabcd54938ec6f9a4498b2bfc', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m10.66 18.36-6.4-6.63A4.57 4.57 0 0 1 3 8.58 4.01 4.01 0 0 1 6.97 4.5 3.93 3.93 0 0 1 9.8 5.72L11 6.94l1.2-1.22a3.93 3.93 0 0 1 2.83-1.22A4.01 4.01 0 0 1 19 8.58a4.5 4.5 0 0 1-1.26 3.15l-6.4 6.63a.44.44 0 0 1-.34.14.44.44 0 0 1-.34-.14", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-heart-filled", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-heart-filled"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-heart-filled":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconHeartFilled$1);
            }
            break;
    } });
}

const CosmosIconHeartFilled = CosmosIconHeartFilled$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconHeartFilled, defineCustomElement };
